import { Component, OnInit, Input } from '@angular/core';
import { ObservablesService } from '../observables.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-super-admin-sidenav',
  templateUrl: './super-admin-sidenav.component.html',
  styleUrls: ['./super-admin-sidenav.component.scss']
})
export class SuperAdminSidenavComponent implements OnInit {
  __loggedUserInfo:any=[];
  // @Input() set loggedUserInfo(value:any){
  //   // console.log("VALUE==",value)
  //   if(value){
  //     this.__loggedUserInfo = value
  //     // console.log("__loggedUserInfo==",this.__loggedUserInfo);
  //     // localStorage.setItem('full_name',this.__loggedUserInfo.full_name);
  //   }
  // }

  constructor(private router:Router,private observables:ObservablesService) { }

  ngOnInit() {
  }

  closeMenu(){
    // console.log('called me')
    this.observables.setMenuStatus({menuState:'out'})
  }


  logOut(){
    this.closeMenu();
    localStorage.clear();
    localStorage.setItem("logOutStatus",'1')
    // this.observables.logout();
    this.router.navigate(['/login']);
  }

  addSubAdmin(){
    this.closeMenu();
    // this.observables.setPage({page:'sub-admin-register',data:{}});
  }

  changePassword(){
    this.closeMenu();
    // this.observables.showPopupStatus.next({changePasswordStatus:true})
  }


  gotoReport(){
    this.closeMenu();
    // this.observables.setPage({page:'report',data:{}});
  }



}
